import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { parseParams } from "../../../helpers/clean-object";

import {
  CreateCategoryMutation,
  CreateCategoryMutationVariables,
} from "../../../__generated__/CreateCategoryMutation";
import { CreateCategoryInput } from "../../../__generated__/globalTypes";
import { CREATE_CATEGORY } from "../categories.queries";

interface IProps {
  defaultValues: CreateCategoryInput;
  onCompleted: () => any;
  onError: (message: string) => any;
}

export const useCreateCategory = ({
  defaultValues,
  onCompleted,
  onError,
}: IProps) => {
  const form = useForm<CreateCategoryInput>({
    mode: "all",
    defaultValues,
  });

  const [mutate, { loading }] = useMutation<
    CreateCategoryMutation,
    CreateCategoryMutationVariables
  >(CREATE_CATEGORY);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createCategory?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createCategory?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
      onError(error.message);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
